'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PxSConverter = require('../../shared/PxSConverter');

var _msToReadableString = require('../../shared/msToReadableString');

var _msToReadableString2 = _interopRequireDefault(_msToReadableString);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _ResizeMonitor = require('./ResizeMonitor');

var _ResizeMonitor2 = _interopRequireDefault(_ResizeMonitor);

var _g11n = require('../../shared/g11n');

var _g11n2 = _interopRequireDefault(_g11n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable consistent-return */
/**
 * Copyright 2013-2016, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * ProgressBar implementation. Currently displays currentTimeMs, durationMs, and expectedDurationMs.
 * The sections of the progress bar are: video up to currentTimeMs, video after currentTimeMs up to
 * durationMs, and video that is after durationMs up to expectedDurationMs.
 * In addition to the different sections of the progress bar, there is a playhead circle that can be
 * used for scrubbing.
 *
 * @providesModule ProgressBar
 */

var ProgressBar = function (_Component) {
  _inherits(ProgressBar, _Component);

  function ProgressBar(props, context) {
    _classCallCheck(this, ProgressBar);

    var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, props, context));

    _this.scrubbing = function (e) {
      var playerId = _this.context.playerId;

      var durationMs = _this.props.durationMs;
      var expectedDurationMs = _this.props.expectedDurationMs;
      var time = (0, _PxSConverter.pxToMs)(e.pageX, expectedDurationMs, playerId);

      if (time <= durationMs && time >= 0) {
        _this.props.emitSoftTimeUpdate(time);
      }
      e.stopPropagation();
    };

    _this.playheadRelease = function () {
      _this.props.setSeeking(false);
      _this.props.setCurrentTimeMs(_this.props.currentTimeMs);
      _this.props.play();
      window.removeEventListener('mousemove', _this.scrubbing);
      window.removeEventListener('mouseup', _this.playheadRelease);
    };

    _this.progressBarMouseMove = function (e) {
      _this.setState({
        mousePositionLeft: e.pageX
      });
    };

    _this.onResize = function () {
      (0, _PxSConverter.clearNodeBoundsCache)();
    };

    _this.state = {
      mouseEntered: false,
      mousePositionLeft: 0,
      relativeMousePositionLeft: 0
    };
    return _this;
  }

  _createClass(ProgressBar, [{
    key: 'playheadClick',
    value: function playheadClick(event) {
      if (event.button === 0) {
        window.addEventListener('mousemove', this.scrubbing);
        this.props.setSeeking(true);
        this.props.pause();
        this.scrubbing(event);
        window.addEventListener('mouseup', this.playheadRelease);
      }
    }
  }, {
    key: 'progressBarGhost',
    value: function progressBarGhost() {
      if (this.state.mouseEntered && this.state.mousePositionLeft >= 0) {
        var _props = this.props,
            durationMs = _props.durationMs,
            expectedDurationMs = _props.expectedDurationMs;

        var mousePositionLeft = this.state.mousePositionLeft;
        var playerId = this.context.playerId;

        var ghostMs = (0, _PxSConverter.pxToMs)(mousePositionLeft, expectedDurationMs, playerId);

        if (this.props.emitGhostTimeUpdate) {
          this.props.emitGhostTimeUpdate(ghostMs);
        }

        var ghostString = ghostMs > durationMs ? (0, _g11n2.default)('vi.progress_bar.video_processing') : (0, _msToReadableString2.default)(ghostMs);
        return _react2.default.createElement('div', {
          className: _style2.default.progressBarGhost,
          style: { width: (0, _PxSConverter.msToPercent)(ghostMs, expectedDurationMs) + '%' },
          'data-content': ghostString
        });
      }
    }
  }, {
    key: 'renderMarks',
    value: function renderMarks() {
      var expectedDurationMs = this.props.expectedDurationMs;
      if (!this.props.getMarkItems || expectedDurationMs <= 0) {
        return null;
      }

      return this.props.getMarkItems({
        playables: this.props.playables,
        playingIndex: this.props.playingIndex
      }).map(function (markItem, index) {
        var left = (0, _PxSConverter.msToPercent)(markItem, expectedDurationMs) + '%';
        return _react2.default.createElement('div', { className: _style2.default.mark, style: { left: left }, key: index });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var time = this.props.currentTimeMs;
      var durationMs = this.props.durationMs;
      var expectedDurationMs = this.props.expectedDurationMs;

      if (time > durationMs) {
        time = durationMs;
      }

      var progress = ((0, _PxSConverter.msToPercent)(time, expectedDurationMs) || 0) + '%';
      var encoding = ((0, _PxSConverter.msToPercent)(expectedDurationMs - durationMs, expectedDurationMs) || 0) + '%';
      var dataAttr = 'data-js-video-' + this.context.playerId;

      var dynamicProps = _defineProperty({}, dataAttr, true);

      var progressAreaStyle = _style2.default.progressArea;
      if (this.props.thick) {
        progressAreaStyle += ' ' + _style2.default.thick;
      }

      if (this.props.expand) {
        progressAreaStyle += ' ' + _style2.default.expand;
      }

      return _react2.default.createElement(
        'div',
        { className: progressAreaStyle, ref: 'wrapper' },
        _react2.default.createElement(
          _ResizeMonitor2.default,
          { onResize: this.onResize },
          _react2.default.createElement(
            'div',
            {
              className: _style2.default.progressBarContainer,
              onMouseDown: function onMouseDown(e) {
                return _this2.playheadClick(e);
              },
              onMouseEnter: function onMouseEnter() {
                return _this2.setState({ mouseEntered: true });
              },
              onMouseLeave: function onMouseLeave() {
                return _this2.setState({ mouseEntered: false });
              },
              onMouseMove: function onMouseMove(e) {
                return _this2.progressBarMouseMove(e);
              }
            },
            this.renderMarks(),
            _react2.default.createElement(
              'div',
              _extends({ className: _style2.default.progressBarBackground }, dynamicProps),
              _react2.default.createElement(
                'div',
                { className: _style2.default.playheadWrapper },
                _react2.default.createElement('div', {
                  style: { width: progress },
                  className: _style2.default.playheadLine
                }),
                _react2.default.createElement('div', {
                  style: { width: encoding },
                  className: _style2.default.encodingLine
                }),
                _react2.default.createElement('div', {
                  style: { left: progress },
                  className: _style2.default.playheadCircle
                })
              ),
              this.progressBarGhost()
            )
          )
        )
      );
    }
  }]);

  return ProgressBar;
}(_react.Component);

ProgressBar.propTypes = {
  currentTimeMs: _propTypes2.default.number,
  durationMs: _propTypes2.default.number,
  expectedDurationMs: _propTypes2.default.number,
  setSeeking: _propTypes2.default.func,
  emitSoftTimeUpdate: _propTypes2.default.func,
  getMarkItems: _propTypes2.default.func,
  setCurrentTimeMs: _propTypes2.default.func,
  play: _propTypes2.default.func,
  pause: _propTypes2.default.func,
  playingIndex: _propTypes2.default.number,
  playables: _propTypes2.default.any,
  thick: _propTypes2.default.bool,
  expand: _propTypes2.default.bool,
  emitGhostTimeUpdate: _propTypes2.default.func
};
ProgressBar.contextTypes = {
  playerId: _propTypes2.default.string
};
exports.default = ProgressBar;
module.exports = exports['default'];